import React from 'react'
import './App.css'
import './Changepassword.css'
import { Redirect } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import { IoLockClosedOutline } from 'react-icons/io5'
import SideNavCust from './layouts/SideNavCust'
import Header from './layouts/Header'
import { BiMenu } from 'react-icons/bi'
import SideNav from './layouts/SideNav'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

class Changepassword extends React.Component {
  constructor(props) {
    const isMobile = window.innerWidth <= 768
    super(props)
    this.state = {
      query: '',
      password: '',
      newPassword: '',
      retypePassword: '',
      response: '',
      error: '',
      successError: '',
      errorDisplay: 'none',
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
    let { customerid, customername } = ''

    if (localStorage.getItem('customername') !== null) {
      customername = localStorage.getItem('customername') + ' - Customer'
      customerid = localStorage.getItem('customerid')
    } else if (localStorage.getItem('businessname') !== null) {
      customername = localStorage.getItem('businessname') + ' - Organiser'
      customerid = localStorage.getItem('businessid')
    } else if (localStorage.getItem('partnername') !== null) {
      customername = localStorage.getItem('partnername') + ' - Affiliate'
      customerid = localStorage.getItem('partnerid')
    }

    document.title = customername + ' - Password'
  }

  handlePass1 = (event) => {
    this.setState({
      newPassword: event.target.value,
      errorDisplay: 'none',
    })
  }

  handlePass2 = (event) => {
    this.setState({
      retypePassword: event.target.value,
      errorDisplay: 'none',
    })
  }

  handlePass3 = (event) => {
    this.setState({
      password: event.target.value,
      errorDisplay: 'none',
    })
  }

  update = () => {
    let { accountid, customername } = ''

    if (localStorage.getItem('customername') !== null) {
      customername = localStorage.getItem('customername')
      accountid = localStorage.getItem('customerid')
    } else if (localStorage.getItem('businessname') !== null) {
      customername = localStorage.getItem('businessname')
      accountid = localStorage.getItem('businessid')
    } else if (localStorage.getItem('partnername') !== null) {
      customername = localStorage.getItem('partnername')
      accountid = localStorage.getItem('partnerid')
    }

    const accounttype = localStorage.getItem('accounttype')

    const password = this.state.password.trim()
    const newPassword = this.state.newPassword
    const retypePassword = this.state.retypePassword

    if (newPassword.length < 8) {
      this.setState({
        error: 'Password should be at least 8 characters long',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else if (newPassword !== retypePassword) {
      this.setState({
        error: 'Make sure both your passwords match',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else if (password === '') {
      this.setState({
        error: 'To update your password, please enter your current one.',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else {
      const baseURL = `${API_URL}/apps/kscanner/webservices.php`
      const data = new FormData()
      data.append('newpassword', newPassword)
      data.append('currentpass', password)
      data.append('accountid', accountid)
      data.append('subquery', accounttype)
      data.append('query', 'CHANGEPASSWORD')

      Axios({
        method: 'POST',
        url: baseURL,
        data: data,
        withCredentials: true,
      })
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              error: response.data.message,
              errorDisplay: 'block',
              successError: 'success-login',
            })
          } else {
            // alert(accountype);
            this.setState({
              error: response.data.message,
              errorDisplay: 'block',
              successError: 'error-login',
            })
          }

          setTimeout(() => {
            this.setState({
              errorDisplay: 'none',
            })
          }, 5000)
        })
        .catch(function (error) {
          alert(error)
        })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  render() {
    let { accountname, dashboard } = ''
    if (localStorage.getItem('customername') === null) {
      if (localStorage.getItem('businessname') === null) {
        if (localStorage.getItem('partnername') === null) {
          return <Redirect to="/login" />
        } else {
          accountname = localStorage.getItem('partnername')
          dashboard = 'in'
        }
      } else {
        accountname = localStorage.getItem('businessname')
        dashboard = 'dashboard'
      }
    } else {
      accountname = localStorage.getItem('customername')
      dashboard = 'customerdashboard'
    }
    const customername = accountname
    const credentials = this.props.location.state.credentials

    const accounttype = localStorage.getItem('accounttype')
    const { collapsed, isMobile } = this.state

    return (
      <div className="view">
        <Header />
        {accounttype === 'customer' ? (
          <>
            {' '}
            <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : (
          <SideNavAff collapsed={this.state.collapsed} onToggle={this.handleToggle} />
        )}

        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={this.handleToggle} />
        )}

        {this.state.isMobile && this.state.collapsed && (
          <label className="mobile-toggle" onClick={this.handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <main
          className="cp-page"
          style={{
            marginTop: 'var(--header-h)',
            marginLeft: this.state.isMobile ? 0 : this.state.collapsed ? '76px' : '252px',
          }}
        >
          <div className="cp-container">
            <button type="button" className="cp-back" onClick={() => this.props.history.goBack()}>
              <IoIosArrowBack size={18} />
              <span>Back</span>
            </button>

            <section className="cp-card">
              <div className="cp-head">
                <div className="cp-head__icon">
                  <IoLockClosedOutline size={22} />
                </div>
                <div>
                  <h1>Change password</h1>
                  <p>Use at least 8 characters.</p>
                </div>
              </div>

              <div className="cp-form">
                <label className="cp-field">
                  <span>New password</span>
                  <input
                    type="password"
                    onChange={this.handlePass1}
                    className="cp-input"
                    autoComplete="new-password"
                  />
                </label>

                <label className="cp-field">
                  <span>Confirm password</span>
                  <input
                    type="password"
                    onChange={this.handlePass2}
                    className="cp-input"
                    autoComplete="new-password"
                  />
                </label>

                <label className="cp-field">
                  <span>
                    Current password <em>(required to confirm changes)</em>
                  </span>
                  <input
                    type="password"
                    onChange={this.handlePass3}
                    className="cp-input"
                    autoComplete="current-password"
                  />
                </label>
              </div>

              <div className="cp-foot">
                <button type="button" className="cp-btn" onClick={() => this.update()}>
                  Save
                </button>
              </div>
            </section>
          </div>
        </main>

        <div
          className={this.state.successError}
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
        >
          {this.state.error}
        </div>
      </div>
    )
  }
}

export default Changepassword
